function filterProductMetafields(product_metafields, variantId) {
    try {
        
        const storeTime = globalFields.Storetime();
        let CustomerTags =
            globalFields?.ShopTAgs != "[]"
                ? globalFields?.ShopTAgs.filter((tag) => globalFields?.CustomerTags?.includes(tag))
                : globalFields?.CustomerTags;
        CustomerTags = CustomerTags ? CustomerTags : [];
        if (globalFields?.isCustomerLogin && CustomerTags.length) {
            product_metafields.CustomerTiers =
                product_metafields.CustomerTiers != "[]" && product_metafields.CustomerTiers.length > 1
                    ? filter_marketRegion(product_metafields.CustomerTiers)
                    : product_metafields.CustomerTiers;
            let customerTiers = null;
            let customerTiersNoDate = null;
            if (product_metafields.CustomerTiers != "[]") {
                const processedTiers = product_metafields.CustomerTiers.map((tierObj) => ({
                    original: tierObj,
                    processed: GetProductTierObject(tierObj, variantId)
                }));
                for (const item of processedTiers) {
                    if (
                        item.processed?.status &&
                        CustomerTags.includes(item.original.tag) &&
                        check_Tier_Validation({ tier: item.processed }, storeTime)
                    ) {
                        if (item.processed.start_date || item.processed.end_date) {
                            if (is_Date_In_Range(item.processed.start_date, item.processed.end_date, storeTime)) {
                                    customerTiers = item.processed;
                            }
                        } else {
                            customerTiersNoDate = item.processed;
                        }
                    }
                }
            }
            if (customerTiers) {
                return customerTiers;
            }
            if (customerTiersNoDate) {
                return customerTiersNoDate;
            }
            product_metafields.CustomerTiersAllProducts =
                product_metafields.CustomerTiersAllProducts != "[]" &&
                product_metafields.CustomerTiersAllProducts.length > 1
                    ? filter_marketRegion(product_metafields.CustomerTiersAllProducts)
                    : product_metafields.CustomerTiersAllProducts;
            let customerTiersAllProducts = null;
            if (product_metafields.CustomerTiersAllProducts != "[]") {
                for (const tierObj of product_metafields.CustomerTiersAllProducts) {
                    const modifiedTierObj = GetProductTierObject(tierObj, variantId);
                    if (
                        CustomerTags.includes(tierObj.tag) &&
                        check_Tier_Validation({ tier: modifiedTierObj }, storeTime)
                    ) {
                        customerTiersAllProducts = modifiedTierObj;
                    }
                }
            }
            if (customerTiersAllProducts) {
                return customerTiersAllProducts;
            }
        }
        product_metafields.NormalTiers =
            product_metafields.NormalTiers != "[]" && product_metafields.NormalTiers.length > 1
                ? filter_marketRegion(product_metafields.NormalTiers)
                : product_metafields.NormalTiers;
        let normalTiers = null;
        let normalTiersNoDate = null;
        if (product_metafields.NormalTiers != "[]" && product_metafields.NormalTiers) {
            const processedNormalTiers = product_metafields.NormalTiers.map(tier => GetProductTierObject(tier, variantId));
            for (const tier of processedNormalTiers) {
                if (tier?.status && check_Tier_Validation(tier, storeTime)) {
                    if (tier.start_date || tier.end_date) {
                        if (is_Date_In_Range(tier.start_date, tier.end_date, storeTime)) {
                            normalTiers = tier;
                        }
                    } else {
                        normalTiersNoDate = tier;
                    }
                }
            }
        }
        if (normalTiers) {
            return normalTiers;
        }
        if (normalTiersNoDate) {
            return normalTiersNoDate;
        }
        product_metafields.NormalTiersAllProducts =
            product_metafields.NormalTiersAllProducts != "[]" && product_metafields.NormalTiersAllProducts.length > 1
                ? filter_marketRegion(product_metafields.NormalTiersAllProducts)
                : product_metafields.NormalTiersAllProducts;
        let normalTiersAllProducts = null;
        if (product_metafields.NormalTiersAllProducts != "[]") {
            for (const tierObj of product_metafields.NormalTiersAllProducts) {
                if (check_Tier_Validation({ tier: tierObj }, storeTime)) {
                    normalTiersAllProducts = tierObj;
                }
            }
        }
        if (normalTiersAllProducts) {
            return normalTiersAllProducts;
        }
        return [];
    } catch (error) {
        console.error("Error in filterProductMetafields:", error);
        return [];
    }
}
function is_Date_In_Range(start_date, end_date, storeTime) {
    try {
        if (start_date && end_date) {
            return storeTime >= start_date && storeTime <= end_date;
        } else if (start_date && !end_date) {
            return storeTime >= start_date;
        } else if (end_date && !start_date) {
            return storeTime <= end_date;
        }
        return false;
    } catch (error) {
        console.error("Error in is_Date_In_Range:", error);
        return false;
    }
}
function check_Tier_Validation(tierObj, storeTime) {
    try {
        let { start_date, end_date, DiscountAppliedON, status, Location_Tag_ ,marketRegion} = tierObj.tier || tierObj;
        let active_market_handle =
            !marketRegion ||
            marketRegion.length == 0 ||
            marketRegion.includes(globalFields.active_market_handle);
        return (
            (start_date === null || storeTime >= start_date) &&
            (end_date === null || storeTime <= end_date) &&
            (DiscountAppliedON === "Both_Store" || DiscountAppliedON === "Online_Store") &&
            status &&
            active_market_handle &&
            (Location_Tag_ != null || filter_Location(tierObj.tier, Location_Tag_))
        );
    } catch (error) {
        console.error("Error in check_Tier_Validation:", error);
        return !1;
    }

}
function filter_Location(tierObj, Location_Tag_) {
    if (Location_Tag_) {
        const locationKey = Object.keys(tierObj.Location_Tag_)[0];
        const tierLocations = tierObj.Location_Tag_[locationKey];
        if (locationKey === "StoreLocation") {
            return tierLocations.includes(globalFields.Storecountry) || tierLocations.includes(globalFields.Storecity);
        }
        const matches = (arr, target) => arr.some((item) => target.includes(item));
        return (
            matches(tierLocations, globalFields.Customercountry) || matches(tierLocations, globalFields.Customercity)
        );
    }
    return !0;
}
function GetProductTierObject(metafieldArray, variantId) {
    try {
        const obj = metafieldArray.tier || metafieldArray;
        if (obj.entity_type === "variants") {
            if (obj.variant_ids.length && Array.isArray(obj.variant_ids)) {
                const variantIndex =
                    obj.variant_ids?.indexOf(String(variantId)) != -1
                        ? obj.variant_ids.indexOf(String(variantId))
                        : obj.variant_ids?.indexOf(Number(variantId));
                if (variantIndex != -1) {
                    return {
                        entity_type: "variants",
                        discount_type: obj.discount_type[variantIndex] || null,
                        status: obj.status[variantIndex] || !1,
                        tier_min: obj.tier_min[variantIndex] || [],
                        tier_max: obj.tier_max[variantIndex] || [],
                        tier_values: obj.tier_values[variantIndex] || [],
                        marketRegion: obj?.marketRegion[variantIndex] || [],
                        start_date: obj.start_date[variantIndex] || null,
                        end_date: obj.end_date[variantIndex] || null,
                        Location_Tag_: obj.Location_Tag_?.[variantIndex] || null,
                        DiscountAppliedON: obj.DiscountAppliedON?.[variantIndex] || null,
                        mostPopularValues: obj.mostPopularValues?.[variantIndex] || [],
                    };
                }
            }
            if (obj.variant_ids == Number(variantId)) {
                return obj;
            }
            return {};
        }
        return obj;
    } catch (error) {
        console.error("Error in GetProductTierObject:", error);
        return {};
    }
}
function validatedCartTierArray(cartTiersArray) {
    try {
        return cartTiersArray.map((tierData) => ({
            product_id: tierData.product_id,
            tiers: filterProductMetafields(tierData.tiers, tierData.variant_id),
            variant_id: tierData.variant_id,
        }));
    } catch (error) {
        console.error("Error in validatedCartTierArray:", error);
        return [];
    }
}
function filter_marketRegion(filterObj) {
    if (filterObj && filterObj.length) {
        filterObj.sort((a, b) => {
            const aHasMarketRegion = a.marketRegion && a.marketRegion.length > 0;
            const bHasMarketRegion = b.marketRegion && b.marketRegion.length > 0;
            if (!aHasMarketRegion && bHasMarketRegion) return 1;
            if (!bHasMarketRegion && aHasMarketRegion) return -1;
            return 0;
        });
    }
    return filterObj;
}
function getProductVariantDetailsById(product, variantId) {
    const variant = product.variants.find((v) => v.id === variantId);
    const title = variant && variant.title ? variant.title : product.title;
    const price = variant && variant.price ? variant.price : product.price;
    return { title, price };
}
